module.exports = __webpack_public_path__ + "static/media/sovellustunnus_unitspotter_logo_kooste.2bad11de.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/images/logos/unitspotterMediaLogos/sovellustunnus_unitspotter_logo_kooste.pdf
// module id = 1447
// module chunks = 0